const StaticData = {
    storeCredentials : {
      'shoppeeUrl' : 'https://www.shopee.co.id/agirosparfum',
      'tokpedUrl': 'https://www.tokopedia.com/agirosparfum',
      'instagramUrl': 'https://www.instagram.com/agirosparfum/',
      'facebookUrl' : 'https://www.facebook.com/share/15qKX7CpVZ/?mibextid=wwXIfr'
    },
    bestSeller : [
      {
        "name": "Iberchem Romawi",
        "inspiredBy": "Romantic Wish",
        "image": require("../assets/images/romawi_perfume.webp"),
        "weight": "1 Kg",
        "shoppeUrl": "https://shopee.co.id/Bibit-Parfum-Iberchem-Romawi-Kemasan-Segel-1-kg-i.1219075929.27750837251",
        "tokpedUrl": "https://www.tokopedia.com/agirosparfum/bibit-parfum-iberchem-romawi-kemasan-segel-1-kg"
      },
      {
        "name": "Iberchem Scarlet",
        "inspiredBy": "Wild Scarlet",
        "image": require("../assets/images/scarlet_perfume.webp"),
        "weight": "1 Kg",
        "shoppeUrl": "https://shopee.co.id/Bibit-Parfum-Iberchem-Scarlet-Kemasan-Segel-1-kg-i.1219075929.26500838291",
        "tokpedUrl": "https://www.tokopedia.com/agirosparfum/bibit-parfum-iberchem-scarlet-kemasan-segel-1-kg"
      },
      {
        "name": "Iberchem Kurat",
        "inspiredBy": "Baccarat Rouge",
        "image": require("../assets/images/kurat_perfume.webp"),
        "weight": "1 Kg",
        "shoppeUrl": "https://shopee.co.id/Bibit-Parfum-Iberchem-Kurat-Kemasan-Segel-1-kg-i.1219075929.24781153381",
        "tokpedUrl": "https://www.tokopedia.com/agirosparfum/bibit-parfum-iberchem-kurat-kemasan-segel-1-kg"
      },
      {
        "name": "Dullberg Christy by Night",
        "inspiredBy": "Cristina Aguirela",
        "image": require("../assets/images/christy_perfume.webp"),
        "weight": "1 Kg",
        "shoppeUrl": "https://shopee.co.id/product/1219075929/26851097240/",
        "tokpedUrl": "https://www.tokopedia.com/agirosparfum/bibit-parfum-dullberg-christy-by-night-kemasan-segel-500-g"
      },
      {
        "name": "Dullberg Candy Lover",
        "inspiredBy": "Candy Love",
        "image": require("../assets/images/candylover_perfume.webp"),
        "weight": "1 Kg",
        "shoppeUrl": "https://shopee.co.id/product/1219075929/27901145647/",
        "tokpedUrl": "https://www.tokopedia.com/agirosparfum/bibit-parfum-dullberg-candy-lover-kemasan-segel-500-g"
      },
      {
        "name": "IFF Cerulean Dust",
        "inspiredBy": "Electric Sky",
        "image": require("../assets/images/cerulandust_perfume.webp"),
        "weight": "1 Kg",
        "shoppeUrl": "https://shopee.co.id/Bibit-Parfum-IFF-Cerulean-Dust-Kemasan-Segel-1-kg-i.1219075929.23790216808",
        "tokpedUrl": "https://www.tokopedia.com/agirosparfum/bibit-parfum-iff-cerulean-dust-kemasan-segel-1-kg"
      },
    ],
    testimoni : [
      {
        "customer": 'akuaku083',
        "testimoni": 'Asyik banget belanja di toko ini; di toko sebelah harganya mahal amat tapi ditoko ini harganya terjangkau dan kualitas nya baik, dan bagus banget',
        "stars": 5,
      },
      {
        "customer": 'dwi_istanaperfum',
        "testimoni": 'Toko sangat amanah...jangan ragu beli disini',
        "stars": 5,
      },
      {
        "customer": 'meykiolev',
        "testimoni": 'Paket sudah diterima dengan selamat packing rapi dan aman. Seller dan kurir ramah, Recommended belanja disini. Dapat sampel banyak sesuai request. Terimakasih seller, semoga bisa jadi langganan.',
        "stars": 5,
      },
      {
        "customer": 'kadiezcepoe',
        "testimoni": 'RECOMENDED SELLER...PALING ROYAL TESTER... COBA KLO AD BINTANG 10.. PASTI KU KASIH DEH... 👍👍👍👍🙏🙏',
        "stars": 5,
      },
      {
        "customer": 'junai5576',
        "testimoni": 'Alhamdulillah barang sudah kami Terima dengan aman terimakasih atas kerjasama nya pokoknya jangan ragu untuk blanja ke toko ini mantull amanah',
        "stars": 5,
      },
      {
        "customer": 'gleezey',
        "testimoni": 'Alhamdulillah sampai dengan selamat, Packaging aman dan proper.',
        "stars": 5,
      },
      {
        "customer": 'fergusonagus',
        "testimoni": 'Gokil sih, kelupaan minta tester tapi diselipin tester Penjual ramahhh bener',
        "stars": 5,
      },
      {
        "customer": 'lylakevinshop',
        "testimoni": 'Pengiriman gercep sekali. Setelah bandingin harga sana sini, ternyata di toko ini yg menurutq paling murah se Indonesia raya. Packing aman. Dpt free 6 tester a roma. Pdhal g minta lho. Kadang ada kan ditoko lain yg minta tester g dikasih. Terimakasih seller. Barokallah',
        "stars": 5,
      },
    ]
  }

export default StaticData;
  